<mat-spinner diameter="100" strokeWidth="8" [style]="{margin: '35% auto'}"></mat-spinner>
